import { Vue } from 'vue-class-component';

import MediaDetails from '@/components/media/media-details/media-details';
import { Media$Type } from '@/types/Media';

const CN = 'document-details';

export default class DocumentDetails extends Vue {
  render() {
    return <MediaDetails class={CN} types={[Media$Type.DOCUMENT]} />;
  }
}
